var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72 7.75C1.72 4.29855 4.63049 1.5 8.22 1.5C11.8095 1.5 14.72 4.29855 14.72 7.75C14.72 11.2015 11.8095 14 8.22 14C4.63049 14 1.72 11.2015 1.72 7.75ZM8.22 2.5C5.20486 2.5 2.76 4.85083 2.76 7.75C2.76 10.6492 5.20486 13 8.22 13C11.2351 13 13.68 10.6492 13.68 7.75C13.68 4.85083 11.2351 2.5 8.22 2.5Z",
    fill: "#EA4537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79001 6.875C6.79001 6.59886 7.02282 6.375 7.31001 6.375H8.35001C8.6372 6.375 8.87001 6.59886 8.87001 6.875V10.5C8.87001 10.7761 8.6372 11 8.35001 11C8.06282 11 7.83001 10.7761 7.83001 10.5V7.375H7.31001C7.02282 7.375 6.79001 7.15114 6.79001 6.875Z",
    fill: "#EA4537"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39999 10.625C6.39999 10.3489 6.63281 10.125 6.91999 10.125H9.77999C10.0672 10.125 10.3 10.3489 10.3 10.625C10.3 10.9011 10.0672 11.125 9.77999 11.125H6.91999C6.63281 11.125 6.39999 10.9011 6.39999 10.625Z",
    fill: "#EA4537"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22 4.0625C8.05288 4.0625 7.8895 4.11015 7.75054 4.19943C7.61158 4.28871 7.50328 4.4156 7.43932 4.56407C7.37537 4.71253 7.35863 4.8759 7.39124 5.03351C7.42384 5.19112 7.50432 5.33589 7.6225 5.44952C7.74067 5.56315 7.89124 5.64054 8.05515 5.67189C8.21906 5.70324 8.38897 5.68715 8.54337 5.62565C8.69777 5.56416 8.82975 5.46002 8.9226 5.3264C9.01545 5.19279 9.065 5.0357 9.065 4.875C9.065 4.65951 8.97598 4.45285 8.81751 4.30048C8.65904 4.1481 8.44411 4.0625 8.22 4.0625Z",
    fill: "#EA4537"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info_circle.df037930ff99b410e72fc728db930bfb.svg";